var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      attrs: { id: "rates" },
      on: {
        submit: function($event) {
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _vm._l(_vm.form.rates, function(rate, index) {
              return _c(
                "b-form-group",
                {
                  key: index,
                  attrs: { label: rate.code, "label-for": rate.code }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: rate.code,
                      type: "number",
                      step: "0.0000000000000001"
                    },
                    model: {
                      value: _vm.form.rates[index].rate,
                      callback: function($$v) {
                        _vm.$set(_vm.form.rates[index], "rate", $$v)
                      },
                      expression: "form.rates[index].rate"
                    }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "float-right",
                attrs: { type: "submit", variant: "primary" }
              },
              [_vm._v("\n        Сохранить и выйти\n      ")]
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-errors" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c0d6558", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c0d6558","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/modals/EditRatesModal.vue
// module id = 967
// module chunks = 0